import { put, takeLatest } from 'redux-saga/effects';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { addMembersToProject } from 'data/projects/actions';
import { add } from 'stores/memberships';
function* addMemberToProjectSaga(action) {
    const { payload } = action;
    const { projectId, members, handleSuccess, handleFailure } = payload;
    try {
        const response = yield ProjectAPI.addMembers(projectId, members);
        if (handleSuccess) {
            handleSuccess(payload);
        }
        yield put(add({
            projectId: ProjectId(projectId),
            memberships: response.map(({ user: { userId }, permissionSet: { permissionSetType: memberType }, joinedAt })=>({
                    userId: UserId(userId),
                    memberType,
                    joinedAt
                }))
        }));
    } catch (error) {
        if (handleFailure) {
            handleFailure(error);
        }
    }
}
export const watchAddMemberToProjectSaga = function*() {
    yield takeLatest(addMembersToProject.type, addMemberToProjectSaga);
};
